import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Col, Row } from 'rsuite';
import 'react-datepicker/dist/react-datepicker.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const HeaderQuoteAi = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [selectedState, setSelectedState] = useState('');
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [acordForm, setAcordForm] = useState('');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="main">
      <div className="pageformBloack fixedEditheader">
        <div className=" container-fluid gx-0 mb-3">
          <div className="pageLeftBlock">
            <div className={`whiteBoxCont quoteHeaderBar ${isScrolled ? 'shadowFilter' : ''}`}>
              <div className="quoteForm-container">
                {/* Header Section with Border Bottom */}
                <Row className="align-items-center">
                  <Col className="d-flex align-items-center gap-2">
                    <div
                      className="back-button"
                      onClick={() => navigate('/quoteAI')}
                      style={{ cursor: 'pointer' }}
                    >
                      <svg
                        className="back-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                      </svg>
                    </div>
                    <div className="navigate_bar">
                      <span className="fw-bold fs-6 mb-1">Create New LOB Quote</span>
                      <div className="breadcrumb lft header_fnt">
                        <Link title="Home" href="/dashboard">
                          Home
                        </Link>
                        <span title="Client" className="curr">
                          /Quote Ai/Dashboard
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeaderQuoteAi;
